"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFlashMessages = exports.rejectDelete = exports.resolveDelete = exports.deleteEntity = exports.rejectUpdate = exports.resolveUpdate = exports.update = exports.rejectCreate = exports.resolveCreate = exports.create = exports.rejectFetchByID = exports.resolveFetchByID = exports.fetchByID = exports.rejectFetchAll = exports.resolveFetchAll = exports.fetchAll = void 0;
/**
 * Creates an action to fetch all entities of a given type
 * @param actionType The type of action to create
 * @param params Pagination and filtering parameters
 */
var fetchAll = function (actionType, params) {
    if (params === void 0) { params = {}; }
    return ({
        type: actionType,
        success: undefined,
        payload: params,
    });
};
exports.fetchAll = fetchAll;
/**
 * Creates a success action for fetching all entities
 * @param actionType The type of action to create
 * @param response The API response containing the entities
 * @param requestParams The parameters used for the request
 */
var resolveFetchAll = function (actionType, response, requestParams) { return ({
    type: actionType,
    success: true,
    payload: __assign(__assign({}, response), { requestParams: requestParams }),
}); };
exports.resolveFetchAll = resolveFetchAll;
/**
 * Creates a failure action for fetching all entities
 * @param actionType The type of action to create
 * @param error The error that occurred
 * @param requestParams The parameters used for the request
 */
var rejectFetchAll = function (actionType, error, requestParams) { return ({
    type: actionType,
    success: false,
    payload: {
        error: error,
        requestParams: requestParams,
    },
}); };
exports.rejectFetchAll = rejectFetchAll;
/**
 * Creates an action to fetch a single entity by ID
 * @param actionType The type of action to create
 * @param id The ID of the entity to fetch
 */
var fetchByID = function (actionType, id) { return ({
    type: actionType,
    success: undefined,
    payload: id,
}); };
exports.fetchByID = fetchByID;
/**
 * Creates a success action for fetching a single entity
 * @param actionType The type of action to create
 * @param response The API response containing the entity
 */
var resolveFetchByID = function (actionType, response) { return ({
    type: actionType,
    success: true,
    payload: response,
}); };
exports.resolveFetchByID = resolveFetchByID;
/**
 * Creates a failure action for fetching a single entity
 * @param actionType The type of action to create
 * @param error The error that occurred
 * @param id The ID of the entity that failed to fetch
 */
var rejectFetchByID = function (actionType, error, id) { return ({
    type: actionType,
    success: false,
    payload: {
        error: error,
        id: id,
    },
}); };
exports.rejectFetchByID = rejectFetchByID;
/**
 * Creates an action to create a new entity
 * @param actionType The type of action to create
 * @param data The data for the new entity
 */
var create = function (actionType, data) { return ({
    type: actionType,
    success: undefined,
    payload: data,
}); };
exports.create = create;
/**
 * Creates a success action for entity creation
 * @param actionType The type of action to create
 * @param response The API response containing the created entity
 */
var resolveCreate = function (actionType, response) { return ({
    type: actionType,
    success: true,
    payload: response,
}); };
exports.resolveCreate = resolveCreate;
/**
 * Creates a failure action for entity creation
 * @param actionType The type of action to create
 * @param error The error that occurred
 * @param data The data that failed to create
 */
var rejectCreate = function (actionType, error, data) { return ({
    type: actionType,
    success: false,
    payload: {
        error: error,
        data: data,
    },
}); };
exports.rejectCreate = rejectCreate;
/**
 * Creates an action to update an existing entity
 * @param actionType The type of action to create
 * @param id The ID of the entity to update
 * @param data The updated data
 */
var update = function (actionType, id, data) { return ({
    type: actionType,
    success: undefined,
    payload: {
        id: id,
        data: data,
    },
}); };
exports.update = update;
/**
 * Creates a success action for entity update
 * @param actionType The type of action to create
 * @param response The API response containing the updated entity
 */
var resolveUpdate = function (actionType, response) { return ({
    type: actionType,
    success: true,
    payload: response,
}); };
exports.resolveUpdate = resolveUpdate;
/**
 * Creates a failure action for entity update
 * @param actionType The type of action to create
 * @param error The error that occurred
 * @param id The ID of the entity that failed to update
 * @param data The data that failed to update
 */
var rejectUpdate = function (actionType, error, id, data) { return ({
    type: actionType,
    success: false,
    payload: {
        error: error,
        id: id,
        data: data,
    },
}); };
exports.rejectUpdate = rejectUpdate;
/**
 * Creates an action to delete an entity
 * @param actionType The type of action to create
 * @param id The ID of the entity to delete
 */
var deleteEntity = function (actionType, id) { return ({
    type: actionType,
    success: undefined,
    payload: id,
}); };
exports.deleteEntity = deleteEntity;
/**
 * Creates a success action for entity deletion
 * @param actionType The type of action to create
 * @param response The API response containing the deleted entity
 */
var resolveDelete = function (actionType, response) { return ({
    type: actionType,
    success: true,
    payload: response,
}); };
exports.resolveDelete = resolveDelete;
/**
 * Creates a failure action for entity deletion
 * @param actionType The type of action to create
 * @param error The error that occurred
 * @param id The ID of the entity that failed to delete
 */
var rejectDelete = function (actionType, error, id) { return ({
    type: actionType,
    success: false,
    payload: {
        error: error,
        id: id,
    },
}); };
exports.rejectDelete = rejectDelete;
/**
 * Creates an action to clear flash messages
 * @param actionType The type of action to create
 */
var clearFlashMessages = function (actionType) { return ({
    type: actionType,
}); };
exports.clearFlashMessages = clearFlashMessages;
